// ChapterView.jsx - Fixed links
import React from 'react';
import { Link, useParams } from 'react-router-dom';

const ChapterView = () => {
  const { memoirId, chapterId } = useParams();
  
  const memoir = {
    title: "Becoming Whole again - My journey through healing",
    type: "Healing & Survival"
  };

  const chapterData = {
    title: "When did you realise you needed healing?",
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 

Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus ex. Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia. Aliquam in elementum tellus.

Curabitur tempor quis eros tempus lacinia. Nam bibendum pellentesque quam a convallis. Sed ut vulputate nisl. Integer in felis sed leo vestibulum venenatis. Suspendisse quis arcu sem. Aenean feugiat ex eu vestibulum vestibulum. Morbi a eleifend magna. Nam metus lacus, porttitor eu mauris a, blandit ultrices nibh. Mauris sit amet magna non ligula vestibulum eleifend.`
  };

  return (
    <div className=" text-left">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <Link to={`/user/memoir/${memoirId}`} className="text-[#8A9099] hover:text-[#0E1628]">
            {memoir.title}
          </Link>
          <span className="text-[#8A9099]">/</span>
          <span className="text-[#0E1628]">Chapter {chapterId}</span>
        </div>

        {/* Navigation Tabs - FIXED PATHS */}
        <div className="flex border-b border-gray-200 mb-6">
          <Link to={`/user/memoir/${memoirId}`} className="px-4 py-2 text-[#8A9099] hover:text-[#0E1628]">
            Overview
          </Link>
          <Link to={`/user/memoir/${memoirId}/chapter/1`} className={`px-4 py-2 ${chapterId === '1' ? 'text-[#0E1628] border-b-2 border-[#55000C] font-medium' : 'text-[#8A9099] hover:text-[#0E1628]'}`}>
            Chapter 1
          </Link>
          <Link to={`/user/memoir/${memoirId}/chapter/2`} className={`px-4 py-2 ${chapterId === '2' ? 'text-[#0E1628] border-b-2 border-[#55000C] font-medium' : 'text-[#8A9099] hover:text-[#0E1628]'}`}>
            Chapter 2
          </Link>
          <Link to={`/user/memoir/${memoirId}/chapter/3`} className={`px-4 py-2 ${chapterId === '3' ? 'text-[#0E1628] border-b-2 border-[#55000C] font-medium' : 'text-[#8A9099] hover:text-[#0E1628]'}`}>
            Chapter 3
          </Link>
          <Link to={`/user/memoir/${memoirId}/chapter/4`} className={`px-4 py-2 ${chapterId === '4' ? 'text-[#0E1628] border-b-2 border-[#55000C] font-medium' : 'text-[#8A9099] hover:text-[#0E1628]'}`}>
            Chapter 4
          </Link>
          <Link to={`/user/memoir/${memoirId}/chapter/5`} className={`px-4 py-2 ${chapterId === '5' ? 'text-[#0E1628] border-b-2 border-[#55000C] font-medium' : 'text-[#8A9099] hover:text-[#0E1628]'}`}>
            Chapter 5
          </Link>
        </div>
      </div>

      {/* Chapter Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Left Column - Question */}
        <div>
          <h1 className="text-2xl font-bold text-[#0E1628] mb-6 uppercase tracking-wide">
            {chapterData.title}
          </h1>
          
          <div className="prose max-w-none">
            {chapterData.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-[#0E1628] leading-relaxed mb-4">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Right Column - Image and Additional Content */}
        <div className="space-y-6">
          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1544027993-37dbfe43562a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
              alt="Chapter illustration" 
              className="w-full h-64 object-cover rounded-lg"
            />
          </div>
          
          <div className="prose max-w-none">
            <p className="text-[#0E1628] leading-relaxed">
              Curabitur tempor quis eros tempus lacinia. Nam bibendum pellentesque quam a convallis. Sed ut vulputate nisl. Integer in felis sed leo vestibulum venenatis. Suspendisse quis arcu sem. Aenean feugiat ex eu vestibulum vestibulum.
            </p>
          </div>
        </div>
      </div>

      {/* Navigation - FIXED PATHS */}
      <div className="flex justify-between mt-12 pt-8 border-t border-gray-200">
        <Link 
          to={`/user/memoir/${memoirId}`}
          className="flex items-center gap-2 px-4 py-2 text-[#8A9099] hover:text-[#0E1628]"
        >
          ← Back to Overview
        </Link>
        
        {parseInt(chapterId) < 5 && (
          <Link 
            to={`/user/memoir/${memoirId}/chapter/${parseInt(chapterId) + 1}`}
            className="flex items-center gap-2 px-4 py-2 bg-primary text-[#0F1F3D] font-medium rounded hover:bg-yellow-600"
          >
            Next Chapter →
          </Link>
        )}
      </div>
    </div>
  );
};

export default ChapterView;